/**
 * 編輯／刪除權限（後端 crm-backend utils/permissions.ts 同一套規則，兩邊要一起改）
 * - SUPER_ADMIN：全部
 * - ADMIN：除了 SUPER_ADMIN 建立的以外都可以
 * - USER：只能動自己建立的
 * 任務、商機的刪除只開放管理員（canAdminDelete）
 */
import { Role } from '@redpanda/types';

/** 後端列表、詳情 API 附在每筆資料上的建立者資訊 */
export interface CreatorInfo {
  createdByName?: string;
  createdByUserId?: string;
  createdByRole?: string;
}

interface Owned extends CreatorInfo {
  userId?: string;
}

const ownerId = (record: Owned) => record.createdByUserId ?? record.userId;

export const canModify = (record: Owned, userRole?: string, currentUserId?: string): boolean =>
  userRole === Role.SUPER_ADMIN ||
  (userRole === Role.ADMIN && record.createdByRole !== Role.SUPER_ADMIN) ||
  (userRole === Role.USER && !!currentUserId && ownerId(record) === currentUserId);

export const canAdminDelete = (record: Owned, userRole?: string): boolean =>
  userRole === Role.SUPER_ADMIN ||
  (userRole === Role.ADMIN && record.createdByRole !== Role.SUPER_ADMIN);
